import React, {useEffect, useRef} from 'react';
import {Route, Switch, useLocation} from 'react-router-dom';
import {Card, Col, Row} from 'react-bootstrap';
import PerfectScrollbar from 'perfect-scrollbar';
import Footer from 'components/Footer/Footer';
import MainNavbar from 'components/Navbars/MainNavbar';
import Sidebar from 'components/Sidebar/Sidebar';
import {useAppContext} from 'contexts/AppContext';
import appRoutes from 'routes/appRoutes';
import {getUserRole} from 'utils/Auth';
import 'react-toastify/dist/ReactToastify.css';

let ps;

export default function AppLayout(props) {
    const isMounted = useRef(false);
    const mainPanel = useRef(null);
    const {pageTitle, loadMaintenanceAlertsCount} = useAppContext();
    const location = useLocation();
    const userRole = getUserRole();

    useEffect(() => {
        isMounted.current = true;
        if (navigator.platform.indexOf('Win') > -1) {
            ps = new PerfectScrollbar(mainPanel.current);
            document.body.classList.toggle('perfect-scrollbar-on');
        }
        loadMaintenanceAlertsCount();
        const intervalId = setInterval(loadMaintenanceAlertsCount, 10000);
        return () => {
            isMounted.current = false;
            clearInterval(intervalId);
            if (navigator.platform.indexOf('Win') > -1) {
                ps.destroy();
                document.body.classList.toggle('perfect-scrollbar-on');
            }
        };
    }, []);

    useEffect(() => {
        mainPanel.current.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
    }, [location]);

    return (
        <div className="wrapper">
            <Sidebar />
            <div className="main-panel" ref={mainPanel}>
                <MainNavbar pageTitle={pageTitle} />
                <div className="content">
                    <Row>
                        <Col md="12">
                            <Switch>
                                {appRoutes.map(route => {
                                    if (!route.roles.includes(userRole)) return null;
                                    return (
                                        <Route
                                          key={route.path.slice(1)}
                                          path={route.path}
                                          render={props => {
                                              const component = <route.component {...props} />;
                                              if (route.name === 'Dashboard') return component;
                                              return (
                                                  <Card border="secondary">
                                                      <Card.Body>{component}</Card.Body>
                                                  </Card>
                                              );
                                          }}
                                        />
                                    );
                                })}
                            </Switch>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
};
